module.exports = __webpack_public_path__ + "img/wallet-05.32617eb0.svg";